import { FC, HTMLAttributes, useEffect } from "react";
import clsx from "classnames";
import { Typography } from "../../core/Typography/Typography";
import { TypographyVariant } from "../../../constants/typography";
import { CoinNumber } from "../../core/CoinNumber/CoinNumber";
import { DURATION_COIN_ANIMATION } from "../../../constants/animation";
import { useStyles } from "./DailyRewardHeader.style";

interface IDailyRewardHeader {
  sizeCoin?: number;
  sizeTypo?: TypographyVariant;
  idCoin?: string;
  nbCoin: number;
  coinAdd?: number;
}

export const DailyRewardHeader: FC<
  HTMLAttributes<HTMLDivElement> & IDailyRewardHeader
> = (props) => {
  const classes = useStyles();
  const {
    sizeCoin,
    sizeTypo,
    idCoin,
    nbCoin,
    coinAdd,
    className,
    ...otherProps
  } = props;

  useEffect(() => {
    if (!coinAdd || !idCoin) return;
    const element = document.getElementById("coin-target-nb");
    let animationFrame: number;
    if (element) {
      const start = Number(element.textContent || 0);
      const end = start + coinAdd;
      const startTime = Date.now();
      const animate = () => {
        const elapsed = Date.now() - startTime;
        const progress = Math.min(elapsed / DURATION_COIN_ANIMATION, 1);
        const current = Math.floor(start + (end - start) * progress);
        element.textContent = String(current);
        if (progress < 1) {
          animationFrame = requestAnimationFrame(animate);
        }
      };
      animate();
    }
    return () => cancelAnimationFrame(animationFrame);
  }, [coinAdd, idCoin]);

  return (
    <div {...otherProps} className={clsx(classes.root, className)}>
      <Typography variant={sizeTypo || TypographyVariant.BodyB6Bold}>
        <CoinNumber type="vodabucks" amount={0} size={sizeCoin || 24} />
      </Typography>
      <Typography variant={sizeTypo || TypographyVariant.BodyB6Bold}>
        <CoinNumber
          type="gzcoins"
          amount={nbCoin}
          size={sizeCoin || 24}
          idCoin={idCoin}
        />
      </Typography>
    </div>
  );
};
